import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

// Components
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// Style
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

const styles = theme => {
  return {
    root: {
      background: theme.palette.common.white,
      display: 'flex',
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      fontSize: 14,
    },
    rootBorder: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    radioGroupRoot: {
      flexDirection: 'row',
    },
    objectKeyCell: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 280,
      width: '36%',
      flex: '1 1 auto',
      padding: theme.spacing(0, 0, 1 / 8, 1 / 2),
    },
    optOutCell: {
      flex: '1 1 auto',
    },
    icons: {
      display: 'flex',
      alignItems: 'center',
    },
    iconButton: {
      marginLeft: theme.spacing(0.5),
    },
  };
};

class AttributeRow extends PureComponent {
  static propTypes = {
    dragIcon: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    moveItem: PropTypes.func.isRequired,
    editPriorityList: PropTypes.func.isRequired,
    configFields: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  };

  state = {
    menuOpen: false,
    anchorEl: null,
  };

  toggleMenu = event => {
    this.setState({
      menuOpen: !this.state.menuOpen,
      anchorEl: event ? event.currentTarget : this.state.anchorEl,
    });
  };

  moveItem = (oldIndex, newIndex) => {
    return () => {
      this.props.moveItem({ oldIndex, newIndex });
      this.setState(prevState => ({
        menuOpen: !prevState.menuOpen,
      }));
    };
  };

  onDelete = () => {
    const { index, editPriorityList, list } = this.props;
    let listClone = [...list];
    listClone.splice(index, 1);
    editPriorityList(listClone);
    this.setState(prevState => ({
      menuOpen: !prevState.menuOpen,
    }));
  };

  onRadioSelect = () => {
    const { list, index, editPriorityList } = this.props;
    let listClone = [...list];
    const attributeClone = {
      ...list[index],
      canOptOut: !list[index].canOptOut,
    };

    listClone.splice(index, 1, attributeClone);
    editPriorityList(listClone);
  };

  optOutBlackList(key) {
    const blackList = {
      education: true,
      experience: true,
      languages: true,
    };

    return blackList[key];
  }

  render() {
    const { configFields, dragIcon, value, index, list, classes } = this.props;
    const isLast = index === list.length - 1;
    const isDisabled = this.optOutBlackList(value.objectKey);
    const field = _get(configFields, `${value.objectKey}`);

    return field ? (
      <div
        className={classNames(classes.root, { [classes.rootBorder]: !isLast })}
        data-testid={`${field.displayName}-sortableRow`}
      >
        <div className={classes.objectKeyCell}>{field.displayName}</div>
        <div className={classes.optOutCell}>
          <RadioGroup
            classes={{ root: classes.radioGroupRoot }}
            aria-label="User Opted Out"
            name="userOptOut"
            value={value.canOptOut ? 'yes' : 'no'}
            onChange={this.onRadioSelect}
          >
            <FormControlLabel
              value="yes"
              disabled={isDisabled}
              label="Yes"
              control={<Radio disabled={isDisabled} />}
            />
            <FormControlLabel
              value="no"
              label="No"
              disabled={isDisabled}
              control={<Radio disabled={isDisabled} />}
            />
          </RadioGroup>
        </div>
        <div className={classes.icons}>
          {list.length > 1 && dragIcon}
          <IconButton
            className={classes.iconButton}
            aria-label="More"
            aria-owns={this.state.menuOpen ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.toggleMenu}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu anchorEl={this.state.anchorEl} open={this.state.menuOpen} onClose={this.toggleMenu}>
            {index !== 0 ? (
              <MenuItem onClick={this.moveItem(index, index - 1)}> Move up </MenuItem>
            ) : null}
            {!isLast ? (
              <MenuItem onClick={this.moveItem(index, index + 1)}> Move down </MenuItem>
            ) : null}
            <MenuItem onClick={this.onDelete}> Remove from completion notifications </MenuItem>
          </Menu>
        </div>
      </div>
    ) : null;
  }
}

export default withStyles(styles)(AttributeRow);
